import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function outcomes() {
  return (
    <section className="outcome outcome_chat p-100 text_chat">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="outcome_img">
              <StaticImage
                src="../../../images/case-studies/our-chat/outcomes.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={632}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              The <span>Outcomes?</span> 
            </h2>
            <p>
              The client was extremely satisfied with the application and
              claimed that it exceeded their expectations. It was also popular
              among users due to its practicality and affordability.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default outcomes;
